module.exports = __webpack_public_path__ + "img/emergency_kit_05.70361277.jpg";